import React, { useState, useEffect } from 'react';
import '../css/Memberships.css';
import line from '../images/underline.png';

import memberships from '../utils/memberships';
import Membership from './cards/Membership';
import { getRemainingTimeUntilMsTimestamp } from '../utils/countdown';

import Image from 'react-image-webp';
import image from '../images/award-background.png';
import imageWebp from '../images/award-background.webp';

import decoration from '../images/decorations/counseling_decoration_2.png';
import black from '../images/black.png';

// const membershipAstuko = memberships
// 	.filter((e) => e.tag === 'atsuko')
// 	.map((training) => (
// 		<Membership
// 			key={training.id}
// 			image={training.image}
// 			icon={training.icon}
// 			title={training.title}
// 			price={training.price}
// 			price_before={training.price_before}
// 			items={training.items}
// 			urls={training.urls}
// 		/>
// 	));

// const membershipFull = memberships
// 	.filter((e) => e.tag === 'full')
// 	.map((training) => (
// 		<Membership
// 			key={training.id}
// 			image={training.image}
// 			icon={training.icon}
// 			title={training.title}
// 			price={training.price}
// 			price_before={training.price_before}
// 			items={training.items}
// 			urls={training.urls}
// 		/>
// 	));

// const MembershipsAtsuko = () => {
// 	const [active, setActive] = useState(false);

// 	useEffect(() => {
// 		setTimeout(() => {
// 			setActive(true);
// 		}, 100);
// 	}, [active]);
// 	return (
// 		<div
// 			className='memberships-filter'
// 			style={
// 				active ? { opacity: 1, transform: 'scale(1)' } : { opacity: 0, transform: 'scale(0.8)' }
// 			}
// 		>
// 			{membershipAstuko}
// 		</div>
// 	);
// };

// const MembershipsFull = () => {
// 	const [active, setActive] = useState(false);

// 	useEffect(() => {
// 		setTimeout(() => {
// 			setActive(true);
// 		}, 100);
// 	}, [active]);
// 	return (
// 		<div
// 			className='memberships-filter'
// 			style={
// 				active ? { opacity: 1, transform: 'scale(1)' } : { opacity: 0, transform: 'scale(0.8)' }
// 			}
// 		>
// 			{membershipFull}
// 		</div>
// 	);
// };

const Memberships = () => {
	const [location, setLocation] = useState(null);

	useEffect(() => {
		const fetchLocation = async () => {
			try {
				const response = await fetch(`https://ipinfo.io/json?token=02e14e8acfee94`);
				const data = await response.json();
				// console.log(data);
				setLocation(data.country);
			} catch (error) {
				console.error('Error fetching the location:', error);
			}
		};
		fetchLocation();
	}, []);

	const countdownTimestampMs = 'Tue, 24 Mar 2026 16:00:00 GMT-5';

	const defaultRemainingTime = {
		seconds: '00',
		minutes: '00',
		hours: '00',
		days: '00',
	};

	const [remainingTime, setRemainingTime] = useState(defaultRemainingTime);
	const [filter, setFilter] = useState('atsuko');

	// const renderMemberships = () => {
	// 	if (filter === 'atsuko') return <MembershipsAtsuko />;
	// 	if (filter === 'full') return <MembershipsFull />;
	// };

	function updateRemainingTime(countdown) {
		setRemainingTime(getRemainingTimeUntilMsTimestamp(countdown));
	}

	useEffect(() => {
		const intervalId = setInterval(() => {
			updateRemainingTime(countdownTimestampMs);
		}, 1000);
		return () => clearInterval(intervalId);
	}, [countdownTimestampMs]);

	return (
		<div className='Memberships' id='entrenamientos'>
			<div className='memberships-container container padding'>
				<Image
					webp={imageWebp}
					src={image}
					alt='Memberships Background'
					className='memberships-image'
				/>
				<img src={decoration} alt='Membership Decoration' className='membership-decoration' />
				<div className='memberships-header'>
					<h1>
						INVERSIÓN DEL
						<br />
						<span>MÁSTER</span>
						<img className='convert-underline' src={line} alt='underline' />
					</h1>
				</div>

				{/* <div className='black-friday'> 
					<img  src={black} alt='black-friday' />
				</div> */}
				{/* <div className='memberships-button'>
					<button
						className={filter === 'atsuko' ? 'button-selected' : null}
						onClick={() => {
							setFilter('atsuko');
						}}
					>
						Solo Atsuko
					</button>
					<button
						className={filter === 'full' ? 'button-selected' : null}
						onClick={() => {
							setFilter('full');
						}}
					>
						Máster Completo
					</button>
				</div> */}
				{/*  */}
				<div className='cnt-countdown'>
					<div className='membership-countdown'>
						<h5 className='membership-countdown-title'>Inicio de clases 24 de marzo</h5>
						<div className='membership-countdown-counter'>
							<div className='membership-countdown-counter-item'>
								<span>Día(s)</span>
								<p>{remainingTime.days}</p>
							</div>
							<div className='membership-countdown-counter-item'>
								<span>Hora(s)</span>
								<p>{remainingTime.hours}</p>
							</div>
							<div className='membership-countdown-counter-item'>
								<span>Minuto(s)</span>
								<p>{remainingTime.minutes}</p>
							</div>
							<div className='membership-countdown-counter-item'>
								<span>Segundo(s)</span>
								<p>{remainingTime.seconds}</p>
							</div>
						</div>
					</div>
				</div>
				{/*  */}
				<div className='memberships-content'>
					{memberships
						.filter((e) => e.tag === 'atsuko')
						.map((training) => (
							<Membership
								key={training.id}
								image={training.image}
								icon={training.icon}
								title={training.title}
								prices={training.prices}
								priceUSD={training.priceUSD}
								price_before={training.price_before}
								items={training.items}
								urls={training.urls}
								country={location}
							/>
						))}
				</div>
			</div>
		</div>
	);
};

export default Memberships;
